import React from 'react';
import Opportunities from '../opportunities';

const Jobvacancies = () => {


  
  return (
   <Opportunities
   pageTitle="Job Vacancies"
  metaTitle="Job Vacancies - FORLAND"
  bannerImage="assets/images/bg1.png"
  breadcrumb="Job Vacancies"
  category='job'
    />
  );
};

export default Jobvacancies;
